export default __webpack_public_path__ + "static/media/copy.39dbf68f.svg";